import * as React from 'react';
export const IcEducation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.07 7.61l-8.5-3.5a1.5 1.5 0 00-1.14 0l-8.5 3.5C2.37 7.84 2 8.39 2 9v7c0 .55.45 1 1 1s1-.45 1-1v-5.17l7.43 3.06c.18.08.38.11.57.11.19 0 .39-.04.57-.11l8.5-3.5a1.505 1.505 0 000-2.78zM12 16c-.46 0-.91-.09-1.33-.26L6 13.82v3.69c0 .59.36 1.13.9 1.37l4.5 1.96c.19.08.39.12.6.12.21 0 .41-.04.6-.12l4.5-1.96c.55-.24.9-.77.9-1.37v-3.69l-4.67 1.92c-.43.18-.87.26-1.33.26z'
      fill='currentColor'
    />
  </svg>
);
